import {
  GET_LABREQUESTDELIVERYRESULT,
  GET_LABREQUESTDELIVERYRESULT_FAIL,
  GET_LABREQUESTDELIVERYRESULT_SUCCESS,
  GET_LABREQUESTDELIVERYRESULTS,
  GET_LABREQUESTDELIVERYRESULTS_FAIL,
  GET_LABREQUESTDELIVERYRESULTS_SUCCESS,
  ADD_NEW_LABREQUESTDELIVERYRESULT,
  ADD_LABREQUESTDELIVERYRESULT_SUCCESS,
  ADD_LABREQUESTDELIVERYRESULT_FAIL,
  UPDATE_LABREQUESTDELIVERYRESULT,
  UPDATE_LABREQUESTDELIVERYRESULT_SUCCESS,
  UPDATE_LABREQUESTDELIVERYRESULT_FAIL,
  DELETE_LABREQUESTDELIVERYRESULT,
  DELETE_LABREQUESTDELIVERYRESULT_SUCCESS,
  DELETE_LABREQUESTDELIVERYRESULT_FAIL,
  SET_STATE_LABREQUESTDELIVERYRESULT
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_LABREQUESTDELIVERYRESULT,
  payload: loading,
})

export const getLabRequestDeliveryResults = ( params ) => ({
  type: GET_LABREQUESTDELIVERYRESULTS,
  payload: { params },
})

export const getLabRequestDeliveryResultsSuccess = (labRequestDeliveryResults, totalPages, currentPage) => ({
  type: GET_LABREQUESTDELIVERYRESULTS_SUCCESS,
  payload: { labRequestDeliveryResults:labRequestDeliveryResults, total:totalPages, currentPage:currentPage}
})

export const getLabRequestDeliveryResultsFail = error => ({
  type: GET_LABREQUESTDELIVERYRESULTS_FAIL,
  payload: error,
})

export const addNewLabRequestDeliveryResult = labRequestDeliveryResult => ({
  type: ADD_NEW_LABREQUESTDELIVERYRESULT,
  payload: labRequestDeliveryResult,
})

export const addLabRequestDeliveryResultSuccess = labRequestDeliveryResult => ({
  type: ADD_LABREQUESTDELIVERYRESULT_SUCCESS,
  payload: labRequestDeliveryResult,
})  

export const addLabRequestDeliveryResultFail = error => ({
  type: ADD_LABREQUESTDELIVERYRESULT_FAIL,
  payload: error,
})

export const updateLabRequestDeliveryResult = labRequestDeliveryResult => ({
  type: UPDATE_LABREQUESTDELIVERYRESULT,
  payload: labRequestDeliveryResult,
})

export const updateLabRequestDeliveryResultSuccess = labRequestDeliveryResult => ({
  type: UPDATE_LABREQUESTDELIVERYRESULT_SUCCESS,
  payload: labRequestDeliveryResult,
})

export const updateLabRequestDeliveryResultFail = error => ({
  type: UPDATE_LABREQUESTDELIVERYRESULT_FAIL,
  payload: error,
})

export const deleteLabRequestDeliveryResult = labRequestDeliveryResult => ({
  type: DELETE_LABREQUESTDELIVERYRESULT,
  payload: labRequestDeliveryResult,
})

export const deleteLabRequestDeliveryResultSuccess = id => ({
  type: DELETE_LABREQUESTDELIVERYRESULT_SUCCESS,
  id,
})

export const deleteLabRequestDeliveryResultFail = error => ({
  type: DELETE_LABREQUESTDELIVERYRESULT_FAIL,
  payload: error,
})

export const getLabRequestDeliveryResult = () => ({
  type: GET_LABREQUESTDELIVERYRESULT,
})

export const getLabRequestDeliveryResultSuccess = labRequestDeliveryResult => ({
  type: GET_LABREQUESTDELIVERYRESULT_SUCCESS,
  payload: labRequestDeliveryResult,
})

export const getLabRequestDeliveryResultFail = error => ({
  type: GET_LABREQUESTDELIVERYRESULT_FAIL,
  payload: error,
})
